(() => {
  function getProgressBar(track) {
    const wrap = track.closest('.rm-products');
    return wrap ? wrap.querySelector('[data-results-progress]') : null;
  }

  function setStaticClass(track) {
    const maxScroll = track.scrollWidth - track.clientWidth;
    const desktop = window.matchMedia('(min-width: 750px)').matches;
    if (maxScroll <= 4 && desktop) {
      track.classList.add('rm-products__track--static');
    } else {
      track.classList.remove('rm-products__track--static');
    }
  }

  function invalidateSegments(track) {
    const bar = getProgressBar(track);
    if (bar) bar.dataset.segN = '';
  }

  function ensureSegments(bar, track) {
    if (!bar) return;
    const n = track.querySelectorAll('[data-results-product-card]').length;
    if (String(n) === bar.dataset.segN && bar.querySelector('.rm-progress__seg')) return;
    bar.dataset.segN = String(n);
    bar.innerHTML = '';
    if (n <= 1) return;
    for (let i = 0; i < n; i += 1) {
      const seg = document.createElement('span');
      seg.className = 'rm-progress__seg';
      seg.setAttribute('data-index', String(i));
      bar.appendChild(seg);
    }
  }

  function clampScroll(track) {
    const mx = track.scrollWidth - track.clientWidth;
    if (track.scrollLeft > mx) track.scrollLeft = Math.max(0, mx);
    if (track.scrollLeft < 0) track.scrollLeft = 0;
  }

  function syncProgress(track) {
    const bar = getProgressBar(track);
    if (!bar) return;

    ensureSegments(bar, track);
    const segments = bar.querySelectorAll('.rm-progress__seg');
    const n = segments.length;
    const maxScroll = track.scrollWidth - track.clientWidth;

    if (maxScroll <= 4 || n === 0) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;

    const p = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
    const active = n <= 1 ? 0 : Math.min(n - 1, Math.round(p * Math.max(0, n - 1)));
    segments.forEach((seg, i) => {
      seg.classList.toggle('is-active', i === active);
    });
  }

  function relayoutTrack(track, { hard } = { hard: false }) {
    if (hard) invalidateSegments(track);

    setStaticClass(track);
    void track.offsetWidth;

    window.requestAnimationFrame(() => {
      setStaticClass(track);
      clampScroll(track);
      const bar = getProgressBar(track);
      ensureSegments(bar, track);
      syncProgress(track);

      window.requestAnimationFrame(() => {
        setStaticClass(track);
        clampScroll(track);
        syncProgress(track);
      });
    });
  }

  function bindTrack(track) {
    if (track.dataset.rmBound === '1') {
      relayoutTrack(track, { hard: true });
      return;
    }
    track.dataset.rmBound = '1';

    let roTimer;
    const scheduleRelayout = () => {
      window.clearTimeout(roTimer);
      roTimer = window.setTimeout(() => relayoutTrack(track, { hard: false }), 80);
    };

    track.addEventListener(
      'scroll',
      () => {
        window.requestAnimationFrame(() => syncProgress(track));
      },
      { passive: true }
    );

    const onBreakpoint = () => {
      invalidateSegments(track);
      track.scrollLeft = 0;
      relayoutTrack(track, { hard: true });
    };

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => scheduleRelayout());
      ro.observe(track);
    } else {
      window.addEventListener('resize', scheduleRelayout);
    }

    if (track.dataset.rmMqBound !== '1') {
      track.dataset.rmMqBound = '1';
      window.matchMedia('(min-width: 750px)').addEventListener('change', onBreakpoint);
      window.matchMedia('(min-width: 990px)').addEventListener('change', onBreakpoint);
    }

    relayoutTrack(track, { hard: true });
  }

  function initSection(sectionEl) {
    const root = sectionEl.matches('.results-module')
      ? sectionEl
      : sectionEl.querySelector('.results-module');
    if (!root) return;

    root.querySelectorAll('[data-results-products]').forEach((t) => bindTrack(t));

    const btn = root.querySelector('[data-results-load-more]');
    if (!btn) return;

    const hiddenItems = root.querySelectorAll('.results-module__item[data-results-hidden="true"]');
    if (!hiddenItems.length) {
      btn.hidden = true;
      return;
    }

    if (btn.dataset.rmLoadBound === '1') return;
    btn.dataset.rmLoadBound = '1';

    btn.addEventListener('click', () => {
      hiddenItems.forEach((item) => {
        item.removeAttribute('hidden');
        item.removeAttribute('data-results-hidden');
      });
      btn.hidden = true;
      window.requestAnimationFrame(() => {
        root.querySelectorAll('[data-results-products]').forEach((t) => bindTrack(t));
      });
    });
  }

  function boot() {
    document.querySelectorAll('.shopify-section').forEach((sec) => {
      if (sec.querySelector('.results-module')) initSection(sec);
    });
  }

  document.addEventListener('shopify:section:load', (ev) => {
    const id = ev.detail && ev.detail.sectionId;
    if (!id) return;
    const el = document.querySelector(`#shopify-section-${id}`);
    if (el) initSection(el);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
